import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  ListItemText,
  ListSubheader,
  Checkbox,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../AuthProvider";
import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export default function QuestionFormCard() {
  const { oId, pId, triggerRefresh } = useAuth();

  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(["", "", "", ""]);
  const [answerKey, setAnswerKey] = useState("");
  const [questionsList, setQuestionsList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [availableTypes, setAvailableTypes] = useState([]);
  const [selectedTypeFilter, setSelectedTypeFilter] = useState("");

  // 🟢 Question Type dynamic input states
  // const [questionTypes, setQuestionTypes] = useState(["Quiz-1", "Quiz-2"]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [newType, setNewType] = useState("");
  const [answerError, setAnswerError] = useState(""); // add this state
  const [optionErrors, setOptionErrors] = useState([]); // array of error messages for each option
const [customTypes, setCustomTypes] = useState([]);
const allTypes = [...new Set([...availableTypes, ...customTypes])];
  const fetchQuestions = async (typeFilter = "") => {
    try {
      setLoading(true);

      const finalType = typeFilter || ""; // ensure we always pass something
      console.log("Fetching questions for type:", finalType);

      const url = `${baseUrl}/api/online/exam/all/${oId}/${pId}?type=${finalType}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch questions");

      const data = await res.json();

      const formatted = data.map((q, index) => ({
        onlineId: q.onlineId || index + 1,
        question: q.question,
        options: [q.option1, q.option2, q.option3, q.option4],
        answerKey: q.answerKey || "",
        type: q.type,
      }));

      setQuestionsList(formatted);
    } catch (error) {
      console.error("Error fetching questions:", error);
      // toast.error("Failed to load questions!", { autoClose: 2000 });
    } finally {
      setLoading(false);
    }
  };

  // 🟢 Fetch Question Types
  const fetchQuestionTypes = async () => {
    try {
      const res = await fetch(`${baseUrl}/api/online/exam/types/${pId}`);
      if (!res.ok) throw new Error("Failed to fetch question types");
      const data = await res.json();

      if (data && data.length > 0) {
        setAvailableTypes(data);
        setSelectedTypeFilter(data[0]); // ✅ Automatically select first type
        fetchQuestions(data[0]); // ✅ Fetch questions for first type immediately
      }
    } catch (error) {
      console.error("Error fetching question types:", error);
      // toast.error("Failed to load question types!", { autoClose: 2000 });
    }
  };

  // 🟢 Load types and questions on mount
  useEffect(() => {
    fetchQuestionTypes();
  }, []);

  // 🟢 Re-fetch when dropdown changes
  useEffect(() => {
    if (selectedTypeFilter) {
      fetchQuestions(selectedTypeFilter);
    }
  }, [selectedTypeFilter]);

  const handleOptionChange = (index, value) => {
    const updatedOptions = [...options];
    updatedOptions[index] = value;
    setOptions(updatedOptions);

    // 🔍 Recheck for duplicates every time any option changes
    const trimmed = updatedOptions.map((opt) => opt.trim().toLowerCase());
    const duplicates = trimmed.filter(
      (opt, idx) => opt && trimmed.indexOf(opt) !== idx,
    );

    // Build fresh error array
    const updatedErrors = updatedOptions.map((opt) =>
      opt && duplicates.includes(opt.trim().toLowerCase())
        ? "Duplicate option value not allowed"
        : "",
    );

    setOptionErrors(updatedErrors);
  };

  // 🟢 Add new Question Type
const handleAddType = () => {
  const trimmed = newType.trim();

  if (!trimmed) return;

  const exists = allTypes.some(
    type => type.toLowerCase() === trimmed.toLowerCase()
  );
console.log("allTypes:", allTypes);
console.log("trying to add:", trimmed);
  if (exists) {
    toast.info("Type already exists!", { autoClose: 1500 });
    return;
  }

  setCustomTypes(prev => [...prev, trimmed]);
  setNewType("");

  

  toast.success("Type added (temporary)", { autoClose: 1200 });
};

  // const handleRemoveType = (index) => {
  //   const updated = availableTypes.filter((_, i) => i !== index);
  //   setQuestionTypes(updated);
  //   setSelectedTypes((prev) => prev.filter((_, i) => i !== index));
  // };

  // 🟢 Submit or Update Question
  const handleSubmit = async () => {
    if (selectedTypes.length !== 1) {
  toast.error("Please select one question type");
  return;
}

const type = selectedTypes[0];

    // Reset previous errors
    setAnswerError("");

    if (!question.trim()) {
      toast.error("Please enter a question", { autoClose: 2000 });
      return;
    }
    // if (options.filter((opt) => opt.trim() !== "").length < 4) {
    //   toast.error("Please enter Four options", { autoClose: 2000 });
    //   return;
    // }
    if (options.filter((opt) => opt.trim() !== "").length < 4) {
      toast.error("Please enter Four options", { autoClose: 2000 });
      return;
    }

    // 🔍 Duplicate option validation
    const trimmedDuplicateOptions = options
      .map((opt) => opt.trim())
      .filter((opt) => opt !== "");
    const duplicates = trimmedDuplicateOptions.filter(
      (opt, idx) => trimmedDuplicateOptions.indexOf(opt) !== idx,
    );
    if (duplicates.length > 0) {
      const newErrors = options.map((opt) =>
        duplicates.includes(opt.trim()) && opt.trim() !== ""
          ? "Duplicate option value not allowed"
          : "",
      );
      setOptionErrors(newErrors);
      toast.error("Duplicate options found — please correct them", {
        autoClose: 2000,
      });
      return;
    }

    if (!answerKey.trim()) {
      setAnswerError("Please enter the correct answer");
      return;
    }

    // ✅ Check if answer matches one of the options
    const trimmedOptions = options.map((opt) => opt.trim().toLowerCase());
    const trimmedAnswer = answerKey.trim().toLowerCase();

    if (!trimmedOptions.includes(trimmedAnswer)) {
      setAnswerError("Answer must match one of the given options");
      return;
    }

    if (selectedTypes.length === 0) {
      toast.error("Please select at least one question type");
      return;
    }

    const payload = { question, options, answerKey, type };
    const formData = new FormData();
    formData.append("question", question);
formData.append("option1", options[0] || "");
formData.append("option2", options[1] || "");
formData.append("option3", options[2] || "");
formData.append("option4", options[3] || "");
formData.append("answerKey", answerKey);
formData.append("type", type);

    try {
      setButtonLoading(true); // ⏳ Start loading
      let res;

      if (editIndex !== null) {
        const qId = questionsList[editIndex]?.onlineId;
        console.log("I am QID:", qId);

        res = await fetch(`${baseUrl}/api/online/exam/update/question/${qId}`, {
          method: "PATCH",
          body: formData,
        });
        if (!res.ok) throw new Error("Failed to update question");

        const updatedList = [...questionsList];
        updatedList[editIndex] = { ...updatedList[editIndex], ...payload };
        setQuestionsList(updatedList);
        setEditIndex(null);

        toast.success("Question updated successfully!", { autoClose: 1200 });
        //  triggerRefresh("quizTypes"); // only re-fetch quiz types
      } else {
        res = await fetch(
          `${baseUrl}/api/online/exam/save/question/${oId}/${pId}`,
          {
            method: "POST",
           
            body: formData
          },
        );
        const responseText = await res.text(); // 🔥 important
        if (!res.ok) throw new Error(responseText || "Failed to add question");
 toast.success("Question added successfully!", { autoClose: 2000 });
        const newQuestion = { onlineId: Date.now(), ...payload };
        setQuestionsList([...questionsList, newQuestion]);

       
        // setRefreshKey((prev) => prev + 1);
        triggerRefresh("quizTypes"); // only re-fetch quiz types
      }

      // ✅ After success — refresh data
      await fetchQuestionTypes(); // refresh type list (in case new type added)
      await fetchQuestions(selectedTypeFilter || type); // refresh questions of selected type

      // ✅ Reset form fields
      setQuestion("");
      setOptions(["", "", "", ""]);
      setAnswerKey("");
      // setSelectedTypes([]);
    } catch (error) {
      toast.error("Something went wrong!", { autoClose: 2000 });
      console.error(error);
    } finally {
      setButtonLoading(false); // ✅ Stop loading
    }
  };

  const confirmDelete = async () => {
    try {
      if (deleteIndex === null) return;

      const questionId = questionsList[deleteIndex]?.onlineId;
      console.log("Question id :" + questionId);
      if (!questionId) {
        toast.error("Invalid question selected!", { autoClose: 1500 });
        return;
      }

      // ✅ Call your API
      await axios.delete(
        `${baseUrl}/api/online/exam/delete/question/${questionId}`,
      );

      // Wait for animation or UX smoothness
      await new Promise((res) => setTimeout(res, 300));

      // ✅ Update local state after successful deletion
      const updatedList = questionsList.filter((_, i) => i !== deleteIndex);
      setQuestionsList(updatedList);
      setDeleteIndex(null);

      toast.success("Question deleted successfully!", { autoClose: 1000 });
    } catch (error) {
      console.error("Error deleting question:", error);
      toast.error("Error deleting question!", { autoClose: 2000 });
    }
  };

  const handleEdit = (index) => {
    const q = questionsList[index];
    setQuestion(q.question);
    setOptions([...q.options]);
    setAnswerKey(q.answerKey);
    setSelectedTypes([q.type] || []);
    setEditIndex(index);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCancel = () => {
    // Reset form fields
    setQuestion("");
    setOptions([""]);
    setAnswerKey("");
    setSelectedTypes([]);
    setEditIndex(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box sx={{ margin: "5% 1%" }}>
      <ToastContainer position="top-right" hideProgressBar closeOnClick />

      <Card
        sx={{
          width: "100%",
          boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
          borderRadius: 4,
          background: "linear-gradient(180deg,#ffffff,#f3f7fa)",
        }}
      >
        <CardContent>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#0d47a1", fontSize: "20px" }}
            >
              {editIndex !== null ? "Update Question" : "Create New Question"}
            </Typography>

            <Button
              startIcon={<RefreshIcon />}
              onClick={fetchQuestions}
              variant="outlined"
              color="secondary"
              size="small"
            >
              Refresh
            </Button>
          </Box>

          {/* Question Inputs */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 2 }}>
            <TextField
              label="Question"
              variant="outlined"
              size="small"
              fullWidth
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              InputProps={{
                sx: {
                  height: 48, // 👈 increase height (default small = 40)
                  fontSize: "15px",
                },
              }}
            />

            {options.map((opt, index) => (
              <TextField
                key={index}
                label={`Option ${index + 1}`}
                variant="outlined"
                size="small"
                value={opt}
                onChange={(e) => handleOptionChange(index, e.target.value)}
                sx={{ flex: "1 1 45%" }}
                error={!!optionErrors[index]} // 👈 MUI red border when true
                helperText={optionErrors[index] || ""} // 👈 inline message under field
                InputProps={{
                  sx: {
                    height: 45,
                    fontSize: "15px",
                  },
                }}
              />
            ))}

            <TextField
              label="Answer"
              variant="outlined"
              size="small"
              fullWidth
              value={answerKey}
              onChange={(e) => {
                setAnswerKey(e.target.value);
                setAnswerError(""); // clear error when typing
              }}
              error={!!answerError}
              helperText={answerError}
              InputProps={{
                sx: {
                  height: 48,
                  fontSize: "15px",
                },
              }}
            />
            {/* Dynamic Question Type Selector */}
            <Grid item xs={12}>
              <FormControl fullWidth sx={{ width: "220px" }}>
                <InputLabel>Question Type</InputLabel>
                <Select
                  multiple
                  value={selectedTypes}
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedTypes(Array.isArray(value) ? value : []);
                  }}
                  renderValue={(selected) =>
                    Array.isArray(selected) ? selected.join(", ") : ""
                  }
                  input={<OutlinedInput label="Question Type" />}
                  MenuProps={{
                    PaperProps: { style: { width: "160px" } },
                  }}
                >
                  {/* Add New Type Inline */}
                  <ListSubheader
                    disableSticky
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      px: 1,
                      py: 1,
                      bgcolor: "background.paper",
                    }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Box display="flex" gap={1} width="100%">
                      <TextField
                        placeholder="Add New Type"
                        size="small"
                        value={newType}
                       onChange={(e) => {
  console.log("onChange value:", e.target.value);
  setNewType(e.target.value);
}}
                        sx={{ width: "80%" }}
                        onKeyDown={(e) => {
                           e.stopPropagation(); // 🔥 important
                            console.log("Key pressed:", e.key);
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleAddType();
                          }
                        }}
                      />
                      <IconButton
                        onClick={(e) => {
                            console.log("Button clicked");
                          e.stopPropagation();
                          handleAddType();
                        }}
                        disabled={!newType?.trim()}
                      >
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </ListSubheader>

                  {allTypes.map((type, index) => (
                    <MenuItem key={index} value={type}>
                      <Checkbox checked={selectedTypes.indexOf(type) > -1} />
                      <ListItemText primary={type} />
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                         
                        }}
                        sx={{ ml: 1 }}
                      >
                        {/* <CloseIcon fontSize="small" /> */}
                      </IconButton>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Button
              variant="contained"
              disabled={buttonLoading}
              sx={{
                px: 5,
                py: 1.5,
                textTransform: "none",
                fontWeight: "bold",
                borderRadius: 2,
                backgroundColor: "#3C3972",
                fontSize: "14px",
                "&:hover": {
                  backgroundColor: "#3C3972",
                },
              }}
              onClick={handleSubmit}
            >
              {buttonLoading ? (
                <>
                  <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                  {editIndex !== null ? "Updating..." : "Submitting..."}
                </>
              ) : editIndex !== null ? (
                "Update"
              ) : (
                "Submit"
              )}
            </Button>
          </Box>

          {/* Question List */}
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress />
            </Box>
          ) : questionsList.length > 0 ? (
            <>
              <Divider sx={{ mb: 2 }} />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 1.5,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                    color: "#1a237e",
                    fontSize: "20px",
                  }}
                >
                  Submitted Questions
                </Typography>

                {/* 🧭 Filter Dropdown */}
                <FormControl
                  size="small"
                  sx={{
                    minWidth: 180,
                    backgroundColor: "#fff",
                    borderRadius: 2,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <InputLabel>Filter by Type</InputLabel>
                  <Select
                    value={selectedTypeFilter}
                    label="Filter by Type"
                    onChange={(e) => setSelectedTypeFilter(e.target.value)}
                  >
                    {availableTypes.map((type, index) => (
                      <MenuItem key={index} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              {questionsList.map((q, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <Accordion
                    sx={{
                      mb: 1,
                      borderRadius: 2,
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 3px 8px rgba(0,0,0,0.08)",
                      "&:before": { display: "none" },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        background: "#e3f2fd",
                        borderRadius: "8px 8px 0 0",
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 600, color: "#0d47a1", flexGrow: 1 }}
                      >
                        {index + 1}. {q.question}
                      </Typography>
                      {/* <IconButton
                        size="small"
                        color="primary"
                        onClick={() => handleEdit(index)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton> */}
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() =>
                          editIndex === index
                            ? handleCancel()
                            : handleEdit(index)
                        }
                      >
                        {editIndex === index ? (
                          <CancelIcon fontSize="small" />
                        ) : (
                          <EditIcon fontSize="small" />
                        )}
                      </IconButton>

                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => setDeleteIndex(index)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </AccordionSummary>

                    <AccordionDetails sx={{ background: "#fafafa" }}>
                      {q.options.map(
                        (opt, i) =>
                          opt && (
                            <Typography
                              key={i}
                              sx={{
                                color: "#333",
                                ml: 2,
                                mb: 0.5,
                                fontSize: "15px",
                              }}
                            >
                              {String.fromCharCode(97 + i)}. {opt}
                            </Typography>
                          ),
                      )}
                      <Typography
                        sx={{
                          ml: 2,
                          mt: 1,
                          fontWeight: "bold",
                          color: "#2e7d32",
                        }}
                      >
                        ✅ Answer: {q.answerKey || "Not specified"}
                      </Typography>
                      <Typography
                        sx={{
                          ml: 2,
                          fontStyle: "italic",
                          color: "#0277bd",
                        }}
                      >
                        Type: {q.type}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </motion.div>
              ))}
            </>
          ) : (
            <Card
              sx={{
                mt: 4,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                borderRadius: 3,
                backgroundColor: "#fafafa",
                textAlign: "center",
                py: 4,
              }}
            >
              <Typography
                variant="body1"
                sx={{ color: "#555", fontWeight: 500 }}
              >
                No questions available yet.
              </Typography>
            </Card>
          )}
        </CardContent>
      </Card>

      {/* 🗑️ Delete Confirmation */}
      <Dialog
        open={deleteIndex !== null}
        onClose={() => setDeleteIndex(null)}
        PaperProps={{
          sx: {
            borderRadius: 4,
            width: 400,
            boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.25)",
            backgroundColor: "#fafafa",
            overflow: "hidden",
          },
        }}
      >
        {/* 🔴 Header */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #ff5252, #e53935)",
            py: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
          }}
        >
          <DeleteIcon sx={{ fontSize: 40, mb: 0.5 }} />
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", letterSpacing: 0.5 }}
          >
            Delete Question
          </Typography>
        </Box>

        {/* 📝 Body */}
        <DialogContent
          sx={{
            py: 3,
            px: 3,
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "15px",
              color: "#444",
              mb: 1.5,
            }}
          >
            Are you sure you want to delete this question?
          </Typography>

          <Typography
            sx={{
              fontSize: "14px",
              color: "#d32f2f",
              fontWeight: 600,
            }}
          >
            This action cannot be undone.
          </Typography>
        </DialogContent>

        {/* ⚙️ Action Buttons */}
        <DialogActions
          sx={{
            justifyContent: "center",
            gap: 2,
            pb: 2.5,
          }}
        >
          <Button
            onClick={() => setDeleteIndex(null)}
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              px: 4,
              py: 1,
              fontWeight: "500",
              borderColor: "#999",
              color: "#555",
              "&:hover": {
                backgroundColor: "#f5f5f5",
                borderColor: "#666",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDelete}
            variant="contained"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              px: 4,
              py: 1,
              fontWeight: "bold",
              backgroundColor: "#e53935",
              boxShadow: "0 3px 8px rgba(229,57,53,0.4)",
              "&:hover": {
                backgroundColor: "#c62828",
              },
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
